import * as React from 'react';
import classnames from 'classnames';
import { Button } from '@grandvisionhq/common';

const OrderCallToAction = ({ labels , routes , isStacked =false  })=>{
    const Buttons = /*#__PURE__*/ React.createElement("div", {
        className: classnames('order-call-to-action', {
            stacked: isStacked
        })
    }, routes.visitMyAccount && /*#__PURE__*/ React.createElement(Button, {
        className: "order-call-to-action__button",
        variant: "outline",
        caption: labels.visitMyAccount,
        "aria-label": labels.visitMyAccount,
        href: routes.visitMyAccount
    }), /*#__PURE__*/ React.createElement(Button, {
        className: "order-call-to-action__button",
        caption: labels.continueShopping,
        "aria-label": labels.continueShopping,
        href: routes.continueShopping
    }));
    return Buttons;
};

export { OrderCallToAction };
//# sourceMappingURL=OrderCallToAction.js.map
